const form = {
  formFieldWrap: {
    clearFieldBtn: 'Limpar',
  },
};

export default form;
